import classnames from 'classnames';
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import {
	useBlockProps,
	RichText,
	__experimentalGetBorderClassesAndStyles as getBorderClassesAndStyles,
	__experimentalGetColorClassesAndStyles as getColorClassesAndStyles,
} from '@wordpress/block-editor';
import { ReactComponent as CloseButton } from './close-button.svg';

export default function save( { attributes } ) {
	const { text, position, isIcon, style, align } = attributes;

	const borderRadius = style?.border?.radius;
	const borderProps = getBorderClassesAndStyles( attributes );

	// Check for old deprecated numerical border radius. Done as a separate
	// check so that a borderRadius style won't overwrite the longhand
	// per-corner styles.
	if ( typeof borderRadius === 'number' ) {
		borderProps.style.borderRadius = `${ borderRadius }px`;
	}

	const colorProps = getColorClassesAndStyles( attributes );

	const buttonClasses = classnames(
		borderProps.className,
		colorProps.className,
		'wp-block-popper__close',
		{
			'wp-block-popper__close--outside': 'outside' === position,
			'wp-block-popper__close--corner': 'corner' === position,
			aligncenter: 'center' === align,
			alignleft: 'left' === align,
		}
	);

	const blockProps = useBlockProps.save( {
		className: buttonClasses,
		style: colorProps.style,
	} );

	const renderButton = () => {
		if ( isIcon ) {
			return (
				<button
					{ ...blockProps }
					data-wp-on--click="actions.close"
				>
					<CloseButton />
				</button>
			);
		}
		return (
			<RichText.Content
				{ ...blockProps }
				tagName="button"
				value={ text || __( 'Close', 'popper' ) }
				data-wp-on--click="actions.close"
			/>
		);
	};

	const renderWrapper = () => {
		if ( 'outside' === position ) {
			return (
				<div className={ 'wp-block-popper__header' }>
					{ renderButton() }
				</div>
			);
		}
		return renderButton();
	};

	return renderWrapper();
}
